import type { ReactNode } from 'react'
import { StateArt } from './StateArt.js'

export type EmptyStateProps = {
  /** Turkish, from content/copy. */
  text: string
  /** The art id for the picture. `misc/empty` unless a screen has a better one. */
  art?: string
  action?: ReactNode
}

export function EmptyState({ text, art = 'misc/empty', action }: EmptyStateProps) {
  return (
    <div className="state">
      <StateArt id={art} />
      <p className="state__text">{text}</p>
      {action}
    </div>
  )
}
